import React, { useMemo } from 'react';
import { colors } from '../../../theme/colors';
var BgEllipse = function (_a) {
    var size = _a.size, modalType = _a.modalType;
    var fill = useMemo(function () {
        switch (modalType) {
            case 'success':
                return colors.cyan1;
            case 'error':
                return colors.red1;
            default:
                return colors.blue1;
        }
    }, [modalType]);
    var dimensions = useMemo(function () {
        switch (size) {
            case 'small':
                if (modalType === null || modalType === void 0 ? void 0 : modalType.startsWith('whale')) {
                    return {
                        width: '420',
                        height: '116',
                        cx: '214',
                        cy: '-31',
                        rx: '299',
                        ry: '147',
                    };
                }
                return {
                    width: '400',
                    height: '92',
                    cx: '200',
                    cy: '-154',
                    rx: '432',
                    ry: '246',
                };
            default:
                return {
                    width: '600',
                    height: '116',
                    cx: '304',
                    cy: -'31',
                    rx: '389',
                    ry: '147',
                };
        }
    }, [size, modalType]);
    return (React.createElement("svg", { width: dimensions.width, height: dimensions.height, fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        React.createElement("ellipse", { cx: dimensions.cx, cy: dimensions.cy, rx: dimensions.rx, ry: dimensions.ry, fill: fill })));
};
export default BgEllipse;
//# sourceMappingURL=BgEllipse.js.map